/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * External dependencies
 */
import styled from 'styled-components';

/**
 * Internal dependencies
 */
import { Z_INDEX_FOOTER } from '../../constants/zIndex';
import ZoomSelector from './zoomSelector';
import { GridViewButton } from './gridview';
import Layers from './layers';
import { FOOTER_MENU_GAP, FOOTER_MARGIN } from './constants';
import ToolbarToggle from './toolbarToggle';

const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  z-index: ${Z_INDEX_FOOTER};
`;

const MenuItems = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: ${FOOTER_MARGIN}px;
  gap: ${FOOTER_MENU_GAP}px;
`;

function PrimaryMenu() {
  return (
    <Wrapper>
      {/* This ID is used for portal rendering of additional menu items, e.g. for custom meta boxes */}
      <MenuItems id="primary-menu-items">
        <ToolbarToggle />
        <ZoomSelector />
        <GridViewButton />
        <Layers />
      </MenuItems>
    </Wrapper>
  );
}

export default PrimaryMenu;
